import { ProductInfoProduct } from '../../../types'

export const isGiftWithSingleVariant = (
  product: ProductInfoProduct,
): boolean => {
  return product.category?.slug === 'gifts' && product.variants?.length === 1
}
